import React from "react";
import { Flex } from "@chakra-ui/react";
import { Export, Print, QuickDraw, QuickView } from "./components";

interface HeaderProps {
  isOnline: boolean;
}

const Header: React.FC<HeaderProps> = ({ isOnline }) => {
  return (
    <Flex
      m={4}
      mb={6}
      justify="space-between"
      p={4}
      bg="gray.100"
      borderRadius="xl"
    >
      <Flex columnGap={3}>
        <QuickView />
        <QuickDraw />
      </Flex>
      {isOnline && (
        <Flex columnGap={3}>
          <Export />
          <Print />
        </Flex>
      )}
    </Flex>
  );
};

export default Header;
